import { render, staticRenderFns } from "./UCT.vue?vue&type=template&id=1897f9e9&"
import script from "./UCT.vue?vue&type=script&lang=js&"
export * from "./UCT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports